'use strict';

export default {
  api: {
    check_rpps: window.drupalSettings.path.baseUrl + 'api/v1/checkRpps',
    get_rpps: window.drupalSettings.path.baseUrl + 'api/v1/getRpps',
  },
  web: {

  },
  user: {
    create: window.drupalSettings.path.baseUrl + 'api/v1/user/',
    show: window.drupalSettings.path.baseUrl + 'api/v1/user/me/',
    update: window.drupalSettings.path.baseUrl + 'api/v1/user/update/',
    check_email: window.drupalSettings.path.baseUrl + 'api/v1/checkEmail',
    check_code_etablissement: window.drupalSettings.path.baseUrl + 'api/v1/checkCodeEtablissement',
    reactivation_user: window.drupalSettings.path.baseUrl + 'api/v1/reactivationUser',
  },
  contact: {
    send: window.drupalSettings.path.baseUrl + 'api/v1/contact/send',
  },
  support: {
    send: window.drupalSettings.path.baseUrl + 'api/v1/support/send',
  },
  login: window.drupalSettings.path.baseUrl + 'user/login',
  forgot_password: window.drupalSettings.path.baseUrl + 'api/v1/user/forgot-password',
  register: window.drupalSettings.path.baseUrl + 'creation-compte',
}
